import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a Jasper Report
 * @param {*} state
 * @param {*} action
 */
export default function jasperReportReducer(state = initialState.jasperReport, action){

    switch(action.type)
    {
        case types.JASPER_LOGIN_REQUEST:
        console.info("JASPER_LOGIN_REQUEST");
            return {...state,
                options: null,
                loginCompleted: false,
                isLoading: true};
        case types.JASPER_LOGIN_SUCCESS:
        console.info("JASPER_LOGIN_SUCCESS");
            return {...state,
                loginCompleted: true,
                isLoading: false};
        case types.JASPER_LOGIN_ERROR:
            return {...state, error: action.data, isLoading: false};

        case types.JASPER_OPTIONS_REQUEST:
        console.info("JASPER_OPTIONS_REQUEST");
            return {...state,
                options: null,
                optionsCompleted: false,
                isLoading: true};
        case types.JASPER_OPTIONS_SUCCESS:
        console.info("JASPER_OPTIONS_SUCCESS");
            return {...state,
                    options: action.data,
                    optionsCompleted: true,
                    isLoading: false};
        case types.JASPER_OPTIONS_ERROR:
            return {...state, error: action.data, isLoading: false};

        case types.JASPER_LOADREPORT_REQUEST:
        console.info("JASPER_LOADREPORT_REQUEST");
            return {...state,
                options: null,
                isLoading: true};
        case types.JASPER_LOADREPORT_SUCCESS:
        console.info("JASPER_LOADREPORT_SUCCESS");
            return {...state,
                    isLoading: false};
        case types.JASPER_LOADREPORT_ERROR:
            return {...state, error: action.data, isLoading: false};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/jasperReportReducer.js